var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.705 4.265a1 1 0 0 0-1.708.718c0 .268.105.525.293.717l3.65 3.85a1.5 1.5 0 0 0 2.12 0l3.645-3.85a1.001 1.001 0 0 0 0-1.435 1 1 0 0 0-1.41 0L9 6.765V1a1 1 0 0 0-2 0v5.745l-2.295-2.48ZM2 14h12V9a1 1 0 0 1 2 0v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9a1 1 0 0 1 2 0v5Z"
  })));
};
export default SvgDownload;